import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UploadWidgetItemSection } from '@shared/utils/enums';
import { BaseResponse, GamesUploadContext, UploadFreeBetLevelsFileResponse, UploadWidgetItemDto } from '@shared/utils/interfaces';
import { Observable } from 'rxjs';

import { freeBetLevelsBulkUploadUrl } from './free-bet-levels-upload.strategy.constant';
import { UploadSectionStrategy } from './upload-strategy.interface';

@Injectable({ providedIn: 'root' })
export class FreeBetLevelsUploadStrategy implements UploadSectionStrategy {
  readonly section = UploadWidgetItemSection.FreeBetLevels;

  private readonly http = inject(HttpClient);

  upload(file: File, record: UploadWidgetItemDto): Observable<BaseResponse<UploadFreeBetLevelsFileResponse>> {
    const context = record.context as GamesUploadContext;

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<BaseResponse<UploadFreeBetLevelsFileResponse>>(freeBetLevelsBulkUploadUrl(), formData, {
      params: {
        regionId: context.regionId,
        widgetRecordUuid: record.uuid,
      },
    });
  }
}
